import SinglePlayGamePreviewData from '../../../../../tableEngine/Script/Game/Data/DataObject/PreviewData/SinglePlayGamePreviewData';
import { MachineState, PlayType } from '../../../../../tableEngine/Script/Game/Data/Model/TableModel';
import { LobbySinglePlayOverviewDataType, LobbySinglePlayPreviewDataType, LobbySinglePlayStatsDataType } from '../../Config/LobbyGamePreviewDataType';

export default class LobbySinglePlayGamePreviewData extends SinglePlayGamePreviewData implements LobbySinglePlayPreviewDataType {
    protected _name: string = '';
    protected _displayName: string = '';
    protected _isFavorite: boolean = false;

    protected _progressiveValue: number | null = null;
    protected _outOfService: boolean = false;

    constructor(hallID: number, gameID: string, playType: PlayType, data: LobbySinglePlayOverviewDataType) {
        super(hallID, gameID, playType, data);
        this._name = data.Name;
        this._displayName = data.DisplayName;
        this.IsFavorite = data.IsFavorite;
    }

    public get Name() {
        return this._name;
    }

    public get DisplayName() {
        return this._displayName;
    }

    public get IsFavorite() {
        return this._isFavorite;
    }
    public set IsFavorite(value: boolean) {
        if (this._isFavorite === value) {
            return;
        }
        this._isFavorite = value;
        this.emit(LobbySinglePlayGamePreviewData.EVENT_TYPE.FAVORITE_STATUS_CHANGED, this._isFavorite);
    }

    public get ProgressiveValue() {
        return this._progressiveValue;
    }

    public get OutOfService() {
        return this._outOfService;
    }

    public get MachineCount() {
        return this.TableCount;
    }

    public get IdleMachineCount() {
        return this.remainingTableCount;
    }

    public updateOverviewData(data: LobbySinglePlayOverviewDataType) {
        this._name = data.Name;
        this._displayName = data.DisplayName;
        this.IsFavorite = data.IsFavorite;
        super.updateOverviewData(data);
    }

    public updateStatsData(data: LobbySinglePlayStatsDataType) {
        this._progressiveValue = data.ProgressiveValue;
        this._outOfService = data.OutOfService;
        this.state = this.Enabled && !this._outOfService ? MachineState.Ready : MachineState.Maintenance;

        this.TableCount = data.MachineCount;
        this.remainingTableCount = data.IdleMachineCount;
        this.playingTableCount = this.TableCount - this.remainingTableCount;
        super.updateStatsData(data);
    }
}
